<template>
  <header :style="{ backgroundColor: bg_color, position: hd_position }" >
    <div>
      <div :class="{ img_hover: hover_flag }" class="web_icon">
        <img
          src="/static/logo.png"
          alt="官网"
          @click="toHome"
          width="200px"
          style="margin-top: -15px"
        />
      </div>
      <div class="header_right">
        <!-- <navbar class="" /> -->
        <el-menu
          :active-text-color="'rgb(229, 134, 18)'"
          :default-active="activeMenu"
          mode="horizontal"
          background-color="#756bb100"
          text-color="#fff"
          @select="handleSelect"
        >
          <navbar-item
            v-for="route in routes2"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          />
        </el-menu>
        <div class="linkTow">
          <!-- <div style="width:200px;line-height: 50px;display: inline;"> -->
            <a href="https://www.kylinyun.com/" target="_blank">{{ lang==='zh'?'麒麟云管理平台': 'Kirin Cloud Platform' }}</a>&nbsp;&nbsp;
          <!-- </div> -->
          <!-- <div> -->
            <a href="https://danclanbiobank.com/" target="_blank">{{ lang==='zh'?'麒麟云样本管理平台': 'Sample Platform' }}</a>
          <!-- </div> -->
        </div>&nbsp;&nbsp;&nbsp;
        <div class="changeLang">
          <span :class="lang==='zh'?'changeColor':''" @click="changeLang('zh')">{{ lang==='zh'?'中': 'CN' }}</span>&nbsp;|
          <span :class="lang==='en'?'changeColor':''" @click="changeLang('en')">EN</span>&nbsp;|
          <a href="https://www.danclancryo.com" target="_blank" rel="noopener noreferrer">{{ lang==='zh' ? '国际站' : 'Ecommerce Web' }}</a>
        </div>
        <!-- <div style="margin-left:20px;color: rgb(0,255,254)">
          <a href="https://www.danclancryo.com" target="_blank" rel="noopener noreferrer">{{ lang==='zh' ? '其他' : 'others' }}</a>
        </div> -->
      </div>

    </div>
  </header>
</template>

<script>
import {
  solution_findAll,
  productArea_findAll
} from '@/api'
import { mapGetters } from 'vuex'
import { children } from '@/router'
import AppLink from './Navbar/Link'
import Navbar from './Navbar'
import NavbarItem from './Navbar/NavbarItem'
export default {
  name: 'Header',
  components: {
    NavbarItem,
    AppLink,
    Navbar,
  },
  props: {
    bg_color: {
      type: String,
      default: 'transparent',
    },
    hd_position: {
      type: String,
      default: 'fixed',
    },
    hover_flag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // lang: 'zh',
      routes2: [
        {
          path: '/',
          meta: {
            titleZh: '首页',
            titleEn: 'Home',
          }
        },
        {
          path: '/solution', // '/solution'
          alwaysShow: true,
          meta: {
            titleZh: '解决方案',
            titleEn: 'Solution',
          },
          children: [
            {
              path: '/solution/1',
              meta: {
                titleZh: '液氮冻存系统'
              }
            },
            {
              path: '/solution/2',
              meta: {
                titleZh: '麒麟云无线监控系统'
              }
            },
            {
              path: '/solution/3',
              meta: {
                titleZh: '麒麟云样本管理系统'
              }
            },
            {
              path: '/solution/4',
              meta: {
                titleZh: '低温耗材'
              }
            }
          ]
        },
        {
          path: '/product',
          alwaysShow: true,
          meta: {
            titleZh: '产品中心',
            titleEn: 'Product',
          },
          children: [
            {
              path: '/product/1',
              meta: {
                titleZh: '液氮冻存系统'
              },
              
            },
            {
              path: '/product/2',
              meta: {
                titleZh: '麒麟云无线监控系统'
              }
            },
            {
              path: '/product/3',
              meta: {
                titleZh: '麒麟云样本管理系统'
              }
            },
            {
              path: '/product/4',
              meta: {
                titleZh: '低温耗材'
              },
              // children: [
              //   {
              //     path: '/product/4/1',
              //     meta: {
              //       title: '低温东村系统'
              //     }
              //   },
              //   {
              //     path: '/product/4/2',
              //     meta: {
              //       title: '低温东村系统2'
              //     }
              //   }
              // ]
            }
          ]
        },
        {
          path: '/about', // '/about'
          meta: {
            titleZh: '走进丹氏',
            titleEn: 'About Us',
          }
        },
        {
          path: '/servicesAndSupport', // '/customer'
          meta: {
            titleZh: '服务与支持',
            titleEn: 'Services & Support',
          }
        },
      ],
      active: '首页',
      titleList: [
        {
          title: '首页',
          titleEn: 'Home',
          link: '/home',
        },
        {
          title: '产品中心',
          titleEn: 'Home',
          link: '/product',
        },
        {
          title: '解决方案',
          titleEn: 'Home',
          link: '#', // '/solution'
        },
        {
          title: '客户案例',
          titleEn: 'Home',
          link: '#', // '/customer'
        },
        {
          title: '关于我们',
          link: '/about', // '/about'
        },
        {
          title: '500',
          link: '/error-500',
        },
      ],
      activeIndex: '1',
      activeIndex2: '1',
    }
  },
  computed: {
    ...mapGetters([
      'beforeNewRoute',
      'lang'
    ]),
    activeMenu() {
      const route = this.$route
      console.log(route)
      // return route.path
      if (route.meta.guidePath) {
        return this.$store.getters.beforeRoute
      } else {
        return this.beforeNewRoute
      }
    }
  },

  mounted() {
    this.active = this.$route.meta.nav
    console.log('11', children)
    this.getSolusion()
    this.getProduct()
  },
  methods: {
    getProduct() {
      productArea_findAll()
        .then(res => {
          var data = res.data.obj
          console.log(data)
          let list = []
          data.forEach(i => {
            if (i.superId === 0) {
              list.push({
                id: i.id,
                path: '/product/' + i.id,
                meta: {
                  titleZh: i.titleZh,
                  titleEn: i.titleEn,
                },
                children: []
              })
            } else {
              list.forEach((j, ind) => {
                console.log(j.id, i.superId, j.id === i.superId)
                if (j.id === i.superId) {
                  // list[ind] = Object.assign(list[ind], {alwaysShow: true,})
                  list[ind].children.push({
                    id: i.id,
                    path: '/product/' + j.id + '/' + i.id,
                    hidden: true,
                    meta: {
                      titleZh: i.titleZh,
                      titleEn: i.titleEn,
                    }
                  })
                }
              })
            }
          })
          this.routes2[2].children = list
          this.$nextTick(() => {
            console.log(list)
            // this.routes2[2].children.forEach(i => {
            //   if (i.children.length>0) {
            //     i.path = i.children[0].path
            //   }
            // })
          })
        })
    },
    getSolusion() {
      solution_findAll()
        .then(res => {
          var data = res.data
          console.log(data)
          const list = data.obj
          let newList = []
          list.forEach(i => {
            newList.push({
              path: '/solution/' + i.id,
              meta: {
                titleZh: i.titleZh,
                titleEn: i.titleEn,
              }
            })
          })
          this.$nextTick(() => {
            this.routes2[1].children = newList
            console.log(this.routes2)
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    changeLang(val) {
      // this.lang = val
      this.$store.dispatch('app/setLang', val)
    },
    
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    selected(title) {
      this.active = title
    },
    toHome() {
      this.$router.push('/')
      this.active = '首页'
    },
  },
}
</script>
<style>
.el-menu--horizontal>.el-menu--popup-bottom-start {
  position: relative;
  left: calc(64px - 50%);
  top: 0;
  min-width: 130px;
  margin-top: 0;
  background-color: rgba(34, 32, 32, 0.507)!important;
}
.el-menu--popup-right-start {
  background-color: rgba(34, 32, 32, 0.507)!important;
}

</style>
<style lang="scss" scoped>
$white: #ffffff;
@mixin rim {
  background: transparent none repeat scroll 0 0;
  content: '';
  height: 10px;
  position: absolute;
  width: 25px;
  visibility: hidden;
  transition: 0.3s ease;
  opacity: 0;
}
header {
  
  color: $white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  // padding: 25px 0;
  height: 105px;
  transition: background-color 1.5s;
  border-bottom: 1px solid #ccc;
  & > div {
    display: flex;
    justify-content: space-between;
    margin: 0 10%;
    .img_hover:hover {
      &::before {
        content: '';
        height: 105px;
        width: 100%;
        position: absolute;
        left: 0%;
        top: 0;
        background-color: transparent;
        background-image: -webkit-linear-gradient(
          -30deg,
          transparent 30%,
          #fff 50%,
          transparent 70%
        ); /*设置渐变的背景，按对角线渐变*/
        background-blend-mode: hard-light; /*设置背景为混合模式下的强光模式*/
        background-size: 200%;
        animation: shine 5s forwards; /*给背景添加动画改变位置*/
      }
    }
    .web_icon {
      img {
        position: absolute;
        z-index: inherit;
        cursor: pointer;
        padding-top: 25px;
      }
    }
    .header_right{
      display: flex;
      font-size: 18px;
      line-height: 108px;
      .linkTow{
        color: rgb(0,255,254);
      }
      .changeLang{
        cursor: pointer;
        .changeColor{
          color: rgb(229, 134, 18);
        }
      }
    }
    ul {
      font-family: 'Arial', 'Microsoft YaHei', '黑体', '宋体', sans-serif;
      font-weight: bold;
      display: flex;
      list-style: none;
      li {
        margin-right: 5px;
        box-sizing: border-box;
        position: relative;
        a {
          display: block;
          line-height: 20px;
          padding: 6px 15px;
          text-decoration: none;
          box-sizing: border-box;
          color: $white;
          position: relative;
          background-color: transparent;
          text-transform: uppercase;
          transition: 0.3s ease;
          &.active {
            color: #ff8724;
            &::before {
              visibility: visible;
              opacity: 1;
              left: 0;
            }
            &::after {
              visibility: visible;
              opacity: 1;
              right: 0;
            }
          }
          &:hover {
            background: none;
            color: #ff8724;
            outline: none;
            &::before {
              visibility: visible;
              opacity: 1;
              left: 0;
            }
            &::after {
              visibility: visible;
              opacity: 1;
              right: 0;
            }
          }
          &::before {
            @include rim;
            border-left: 1px solid #ff8724;
            border-top: 1px solid #ff8724;
            top: 0;
            left: -70px;
          }
          &::after {
            @include rim;
            border-right: 1px solid #ff8724;
            border-bottom: 1px solid #ff8724;
            bottom: 0;
            right: 70px;
          }
        }
      }
    }
  }
}
// 动画
@keyframes shine {
  from {
    background-position: 130%;
  }
  to {
    background-position: -50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue